import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/footer";
import Header from "../components/header";
import SubscribeContact from "../components/subscribeContact";
import TableOfContents from "../components/table-of-contents";
import TopNavabr from "../components/topNavabr";
import { smartHomeSubmenus } from "../data/smart-home-submenu";
import { useScrollTop } from "../hook/useScrollTop";
import smartHomeBanner from "../images/smart-homes/smart-home-banner.webp";
import EcoSystem from "../sections/smart-home/eco-system";
import MechanicalMlectrical from "../sections/smart-home/mechanical-electrical";
import SmartHomeSolution from "../sections/smart-home/smart-home-solution";
import SmartHomeSystem from "../sections/smart-home/smart-home-system";

const SmartHomes = () => {
  useScrollTop();
  return (
    <>
      <Helmet>
        <title>AFRO || Smart Homes</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={smartHomeBanner}>
        <div className="pt-7 pb-md-5 text-center">
          <h1 className="fs-56 lh-64 gilroy-bold my-4 text-capitalize flex align-items-center header-background-image-size">
            Smart Homes
          </h1>
          <p className="fs-28 gilroy-bold">"Love Life Live Smart"</p>
        </div>
      </Header>
      <div className="d-none d-lg-block">
        <ul className="row fs-14 bg-light list-style-none text-center gilroy-bold m-0 p-0">
          {smartHomeSubmenus.map((route) => (
            <li
              key={route.label}
              className="col-3 border-gray w-full submenu-link"
            >
              <a
                href={route.link}
                className="text-decoration-none py-4 d-block"
              >
                {route.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <TableOfContents routes={smartHomeSubmenus} />
      <SmartHomeSolution />
      <EcoSystem />
      <SmartHomeSystem />
      <MechanicalMlectrical />
      <SubscribeContact />
      <Footer />
    </>
  );
};

export default SmartHomes;
